import Highcharts from 'highcharts';

export const baseGraphConfigs: Highcharts.Options = {
  plotOptions: {
    line: {
      states: {
        hover: {
          color: 'inherit'
        },
        select: {
          color: 'inherit'
        }
      },
      dataLabels: {
        enabled: true,
        format: '${y}'
      }
    },
    column: {
      dataLabels: {
        enabled: true,
        format: '{y}%'
      }
    }
  },
  credits: {
    enabled: false
  },
  exporting: {
    enabled: false
  },
  chart: {
    height: 225
  },
  title: {
    text: ''
  },
  yAxis: {
    title: {
      text: ''
    }
  },
  xAxis: {
    labels: {
      enabled: false
    }
  },
  legend: {
    enabled: false
  }
};
export const legends: Highcharts.SeriesOptionsType[] = [
  {
    type: 'line',
    color: '#003399',
    name: 'Net Sales',
    data: [29.9, 71.5, 106.4, 129.2, 144.0, 176.0, 135.6, 148.5, 216.4, 194.1, 95.6, 54.4]
  },
  {
    type: 'line',
    color: '#115C72',
    name: 'Sales Forecast',
    data: [144.0, 176.0, 135.6, 148.5, 216.4, 194.1, 95.6, 54.4, 29.9, 71.5, 106.4, 129.2],
    yAxis: 1
  },
  {
    type: 'line',
    color: '#660066',
    name: 'Amazon POS',
    data: [300.0, 186.0, 235.6, 548.5, 116.4, 94.1, 105.6, 504.4, 209.9, 710.5, 16.4, 19.2],
    yAxis: 1
  },
  {
    type: 'line',
    color: '#33CCCC',
    name: 'Amazon Glance Views',
    data: [4.0, 276.0, 135.6, 48.5, 116.4, 394.1, 95.6, 4.4, 290.9, 701.5, 16.4, 29.2],
    yAxis: 1
  }
];
